import { render } from "./AboutMePage.vue?vue&type=template&id=70b4c371&scoped=true"
import script from "./AboutMePage.vue?vue&type=script&lang=js"
export * from "./AboutMePage.vue?vue&type=script&lang=js"

import "./AboutMePage.vue?vue&type=style&index=0&id=70b4c371&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70b4c371"]])

export default __exports__